
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanEast as ObiBuoyCanEastElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-east.js';
 
 
 

 
 export const ObiBuoyCanEast = createComponent({
   react: React,
   tagName: 'obi-buoy-can-east',
   elementClass: ObiBuoyCanEastElement,
   events: {
     
   }
  });
 
 